// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav_bar_partner_link[data-v-33d61eeb]{align-items:center;display:flex;font-size:1rem;line-height:1.5rem;margin-bottom:1.5rem;margin-top:1.5rem;--tw-text-opacity:1;color:#64687e;color:rgba(100,104,126,var(--tw-text-opacity))}@media (min-width:1024px){.nav_bar_partner_link[data-v-33d61eeb]{font-size:.75rem;line-height:1rem;margin-bottom:0;margin-top:.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
